import {
  SET_POST_OFFICES
} from 'src/store/mutation-types'

const setPostOffice = ({commit}, postOffice) => {
  commit(SET_POST_OFFICES, postOffice)
}

export default {
  setPostOffice
}



// WEBPACK FOOTER //
// ./src/components/postOffice/store/actions.js